var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.833 20.8066V19.1933C10.833 18.24 11.6122 17.4516 12.5747 17.4516C14.2338 17.4516 14.9122 16.2783 14.078 14.8391C13.6013 14.0141 13.8855 12.9416 14.7197 12.465L16.3055 11.5575C17.0297 11.1266 17.9647 11.3833 18.3955 12.1075L18.4963 12.2816C19.3213 13.7208 20.678 13.7208 21.5122 12.2816L21.613 12.1075C22.0438 11.3833 22.9788 11.1266 23.703 11.5575L25.2888 12.465C26.123 12.9416 26.4072 14.0141 25.9305 14.8391C25.0963 16.2783 25.7747 17.4516 27.4338 17.4516C28.3872 17.4516 29.1755 18.2308 29.1755 19.1933V20.8066C29.1755 21.76 28.3963 22.5483 27.4338 22.5483C25.7747 22.5483 25.0963 23.7216 25.9305 25.1608C26.4072 25.995 26.123 27.0583 25.2888 27.535L23.703 28.4425C22.9788 28.8733 22.0438 28.6166 21.613 27.8925L21.5122 27.7183C20.6872 26.2791 19.3305 26.2791 18.4963 27.7183L18.3955 27.8925C17.9647 28.6166 17.0297 28.8733 16.3055 28.4425L14.7197 27.535C13.8855 27.0583 13.6013 25.9858 14.078 25.1608C14.9122 23.7216 14.2338 22.5483 12.5747 22.5483C11.6122 22.5483 10.833 21.76 10.833 20.8066Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 22.9788C21.645 22.9788 22.9788 21.645 22.9788 19.9997C22.9788 18.3543 21.645 17.0205 19.9997 17.0205C18.3543 17.0205 17.0205 18.3543 17.0205 19.9997C17.0205 21.645 18.3543 22.9788 19.9997 22.9788Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.f2d0c286.svg";
export { ForwardRef as ReactComponent };